import { render, staticRenderFns } from "./CitationListDiscrepancies.vue?vue&type=template&id=aaf992a0"
import script from "./CitationListDiscrepancies.vue?vue&type=script&lang=js"
export * from "./CitationListDiscrepancies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports